'use strict';

var ROMAnalysisFiltersWithoutPaxBrushFactory = function ROMAnalysisFiltersWithoutPaxBrushFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMNonStopFilterFactory', 'ROMServicesFilterFactory', 'ROMServiceTypeFilterFactory', 'ROMAnalysisCabinFilterFactory', 'ROMOptGroupWeekFilterFactory', 'ROMAnalysisPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ROMAnalysisFiltersWithoutPaxBrush() {
    DemandFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode'], ['service-opportunities', 'spill-pax-gap', 'recap-pax-gap', 'spill-service-dtd-pax-gap', 'recap-service-dtd-pax-gap', 'spill-dtd-dow-pax-gap', 'recap-dtd-dow-pax-gap', 'net-spill-rates']);
    this.registerFilters(injectedFilters);
  }
  ROMAnalysisFiltersWithoutPaxBrush.constructor = ROMAnalysisFiltersWithoutPaxBrush;
  ROMAnalysisFiltersWithoutPaxBrush.prototype = Object.create(DemandFilter.prototype);
  ROMAnalysisFiltersWithoutPaxBrush.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ROMAnalysisFiltersWithoutPaxBrush;
};
ROMAnalysisFiltersWithoutPaxBrushFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ROMAnalysisFiltersWithoutPaxBrushFactory;